import { useHiddenViewerOnMount } from "helpers/behaviors/InternetExplorerContext";
import { Modal, Pane, Paragraph, Text } from "components/materials";
import { majorScale } from "helpers/utilities";

export function Confirm({
  content,
  header,
  hideViewer = false,
  onConfirm,
  onCancel = () => {},
  onCloseComplete,
  open,
  warningMessage = "",
  ...props
}) {
  useHiddenViewerOnMount(hideViewer && open);

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      onClose={onCloseComplete}
      onConfirm={onConfirm}
      title={header}
      hasFooter
      {...props}
    >
      <Paragraph>{content}</Paragraph>
      {warningMessage && (
        <Pane marginTop={majorScale(1)}>
          <Text fontWeight={800}>{warningMessage}</Text>
        </Pane>
      )}
    </Modal>
  );
}

Confirm.defaultProps = {
  hideViewer: false,
  onCancel: undefined,
  cancelLabel: "No",
  confirmLabel: "Yes",
};

export default Confirm;
